define('modules/form_editor/models/base_form_element',['require','exports','module','backbone','i18n','lib/util','../../editor/services/integrations/index'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      i18n = require("i18n"),
      util = require("lib/util");

  var IntegrationsService = require("../../editor/services/integrations/index");

  module.exports = Backbone.Model.extend({
    isSocialBindable: false,
    isIntegrable: true,
    defaults: {
      labelText: $.i18n.t("formEditor.label"),
      labelVisible: true,
      isRequired: false,
      widthClass: "one-whole",
      elementId: ""
    },
    //i18n key for default validation message
    defaultErrorMsgKey: "formEditor.validationMessages.required",
    initialize: function(attributes,options){
      _.each(this.defaultValues, function(value,key){
        if(!this.has(key)){
          this.set(key, value);
        }
      }, this);

      this.backwardsCompat(attributes);
    },
    backwardsCompat: function(attributes) {
      if (!this.has("nameAttr")) {
        this.set("nameAttr", attributes.labelText);
        this.once("change:labelText", function(model,value){
          model.set("nameAttr", util.sanitizeString(value));
        });
      }
    },
    getModifiedIntegrations: function(){
      var lastValue = this.previous("nameAttr"),
          services = [];
      if (this.hasChanged("nameAttr")) {
        services = IntegrationsService.checkVariable(lastValue);
      }
      return services.join(", ");
    },
    toJSON: function(){
      var flatModel = module.exports.__super__.toJSON.apply(this);
      _.omit(flatModel, "isSocialBindable");
      if(this.items){
        _.extend(flatModel, { items: this.items.toJSON() });
      }
      return flatModel;
    },
    _hasNumericSuffix: function() {
      var parts = this.get("labelText").split(" "),
          last = _.last(parts);
      return !isNaN(+last);
    },
    _incrementNumericSuffix: function() {
      var parts = this.get("labelText").split(" "),
          last = _.last(parts);
      last = +last + 1;
      this.set({labelText: parts.slice(0, -1).concat(last).join(" ") });
    },
    _addNumericSuffix: function() {
      var labelText = this.get("labelText");
      this.set({labelText: labelText + " 2"});
    },
    isInSocialForm: function() {
      return this.collection.hasSocialLogin();
    },
    cleanSocialBinding: function() {
      if (this.isSocialBindable) {
        this.set("socialBinding", ""); //, {silent: true});
      }
    },
    clone: function() {
      var clone = module.exports.__super__.clone.apply(this, arguments);
      if (this._hasNumericSuffix()) {
        clone._incrementNumericSuffix();
      } else {
        clone._addNumericSuffix();
      }
      return clone;
    },
    getIntegrationData: function() {
      var data = {},
          name = this.get("nameAttr"),
          binding = this.get("correodirectBinding");
      if (binding) data[name] = binding;
      return data;
    },
    getFormEditorMessage: function(name, params) {
      return this.get(name) || $.i18n.t("formEditor." + name + "Value", params);
    }
  });
});

